// extracted by mini-css-extract-plugin
export default {"main":"Comment_main__DyVsx","comment_main":"Comment_comment_main__epqmm"};